import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Resolve upload paths (e.g. /api/uploads/x.png) to absolute URLs
export const resolveImg = (url) => {
  if (!url) return url;
  if (url.startsWith("http")) return url;
  if (url.startsWith("/api")) return `${BACKEND_URL}${url}`;
  return url;
};

const client = axios.create({ baseURL: API });

// Attach admin token if present
client.interceptors.request.use((config) => {
  const token = localStorage.getItem("bfm_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// ---- Public ----
export const fetchProducts = (category) =>
  client.get("/products", { params: category ? { category } : {} }).then((r) => r.data);
export const searchProducts = (q) =>
  client.get("/products", { params: { q } }).then((r) => r.data);
export const fetchProduct = (id) => client.get(`/products/${id}`).then((r) => r.data);
export const fetchBlog = () => client.get("/blog").then((r) => r.data);
export const fetchBlogPost = (slug) => client.get(`/blog/${slug}`).then((r) => r.data);
export const fetchSettings = () => client.get("/settings").then((r) => r.data);
export const submitQuote = (data) => client.post("/quotes", data).then((r) => r.data);
export const subscribeNewsletter = (email) =>
  client.post("/newsletter", { email }).then((r) => r.data);
export const sendChat = (message, session_id) =>
  client.post("/chat", { message, session_id }).then((r) => r.data);
export const uploadDesignImage = (dataUrl) =>
  client.post("/design-upload", { dataUrl }).then((r) => r.data);
export const fetchChatbotConfig = () => client.get("/chatbot/config").then((r) => r.data);
export const fetchContent = () => client.get("/content").then((r) => r.data);
export const updateContent = (data) => client.put("/content", data).then((r) => r.data);
export const fetchCategories = () => client.get("/categories").then((r) => r.data);
export const createCategory = (data) => client.post("/categories", data).then((r) => r.data);
export const updateCategory = (slug, data) => client.put(`/categories/${slug}`, data).then((r) => r.data);
export const deleteCategory = (slug) => client.delete(`/categories/${slug}`).then((r) => r.data);

// ---- Auth ----
export const adminLogin = (username, password) =>
  client.post("/auth/login", { username, password }).then((r) => r.data);
export const adminMe = () => client.get("/auth/me").then((r) => r.data);

// ---- Admin: products ----
export const createProduct = (data) => client.post("/products", data).then((r) => r.data);
export const updateProduct = (id, data) => client.put(`/products/${id}`, data).then((r) => r.data);
export const deleteProduct = (id) => client.delete(`/products/${id}`).then((r) => r.data);

// ---- Admin: blog ----
export const createBlog = (data) => client.post("/blog", data).then((r) => r.data);
export const updateBlog = (slug, data) => client.put(`/blog/${slug}`, data).then((r) => r.data);
export const deleteBlog = (slug) => client.delete(`/blog/${slug}`).then((r) => r.data);

// ---- Admin: settings ----
export const updateSettings = (data) => client.put("/settings", data).then((r) => r.data);

// ---- Admin: chatbot config ----
export const fetchChatbotConfigFull = () => client.get("/chatbot/config/full").then((r) => r.data);
export const updateChatbotConfig = (data) => client.put("/chatbot/config", data).then((r) => r.data);

// ---- Admin: quotes ----
export const fetchQuotes = () => client.get("/quotes").then((r) => r.data);
export const markQuoteRead = (id) => client.put(`/quotes/${id}/read`).then((r) => r.data);
export const deleteQuote = (id) => client.delete(`/quotes/${id}`).then((r) => r.data);

// ---- Upload ----
export const uploadImage = (file) => {
  const form = new FormData();
  form.append("file", file);
  return client
    .post("/upload", form, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};

export default client;
